// frontend/src/data/galleryData.js
export const albums = [
  {
    title: 'Highview Service Day',
    images: [
      '/images/gallery/higview-house-service-day/img_2440.webp',
      '/images/gallery/higview-house-service-day/img_2442.webp',
      '/images/gallery/higview-house-service-day/img_4565.webp',
      '/images/gallery/higview-house-service-day/img_4568.webp',
      '/images/gallery/higview-house-service-day/img_4572.webp',
      '/images/gallery/higview-house-service-day/img_4573.webp',
      '/images/gallery/higview-house-service-day/img_4581.webp',
      '/images/gallery/higview-house-service-day/img_4585.webp',
      '/images/gallery/higview-house-service-day/img_4587.webp',
      '/images/gallery/higview-house-service-day/img_4599.webp',
      '/images/gallery/higview-house-service-day/img_4601.webp',
      '/images/gallery/higview-house-service-day/img_4603.webp',
      '/images/gallery/higview-house-service-day/img_4608.webp',
      '/images/gallery/higview-house-service-day/img_4609.webp',
      '/images/gallery/higview-house-service-day/img_4612.webp',
      '/images/gallery/higview-house-service-day/img_4614.webp',
      '/images/gallery/higview-house-service-day/img_4615.webp',
      '/images/gallery/higview-house-service-day/img_4624.webp',
      '/images/gallery/higview-house-service-day/img_4632.webp',
      '/images/gallery/higview-house-service-day/img_8740.webp',
      '/images/gallery/higview-house-service-day/img_8841.webp',
    ],
  },
  {
    title: 'Chinese Speaking Retreat',
    images: [
      '/images/gallery/chinese-speaking-retreat/csw251003-04.webp',
      '/images/gallery/chinese-speaking-retreat/csw251003-07.webp',
      '/images/gallery/chinese-speaking-retreat/csw251003-12.webp',
      '/images/gallery/chinese-speaking-retreat/csw251003-14.webp',
      '/images/gallery/chinese-speaking-retreat/csw251003-19.webp',
      '/images/gallery/chinese-speaking-retreat/csw251003-20.webp',
      '/images/gallery/chinese-speaking-retreat/csw251003-26.webp',
      '/images/gallery/chinese-speaking-retreat/csw251003-29.webp',
      '/images/gallery/chinese-speaking-retreat/csw251003-34.webp',
      '/images/gallery/chinese-speaking-retreat/csw251003-38.webp',
      '/images/gallery/chinese-speaking-retreat/csw251003-39.webp',
      '/images/gallery/chinese-speaking-retreat/csw251003-40.webp',
      '/images/gallery/chinese-speaking-retreat/untitled-design-1.webp',
    ],
  },
  {
    title: 'Kennesaw Sisters Weekend',
    images: [
      '/images/gallery/kennesaw-sisters-weekend/untitled-design-2.webp',
      '/images/gallery/kennesaw-sisters-weekend/untitled-design-3.webp',
      '/images/gallery/kennesaw-sisters-weekend/untitled-design-4.webp',
    ],
  },
];